import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getWeeklyReportVersionLineChartStat } from '@op/services';
import { DBO_REQ } from '@op/utils/format';
import { TRequestBackType } from '@op/utils/requestUtil';
import { useEffect, useState } from 'react';
import { SortLoadingKeysType } from '../type';
import { useSortLoading } from '@op/models/commonLoading/useSortLoading';

export function useVersionLineChart({
  filter,
  type,
  metricItem,
}: {
  filter: any;
  type: string;
  metricItem: any;
}) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({});
  const { finishLoading } = useSortLoading<SortLoadingKeysType>();
  const [data, setData] = useState<TRequestBackType>({});

  function getVersionLineChartData() {
    let fieldName = [type];
    if (type === 'all') {
      fieldName = [];
    }
    setData({});
    wrapperCancelRequest(getWeeklyReportVersionLineChartStat, {
      ...filter,
      group_fields: fieldName,
      metrics: metricItem.key,
      top_n: 15,
    })
      .then((data: any) => {
        const { start_time, end_time, weekly_version_single_list } = data || {};
        if (
          !weekly_version_single_list ||
          weekly_version_single_list.length === 0
        ) {
          setData({ isEmpty: true });
          return;
        }

        const info = DBO_REQ.listKeys(
          {
            timeline: weekly_version_single_list,
            valueKey: 'val',
          },
          {
            timeline_of_start_time: start_time,
            timeline_of_end_time: end_time,
            filter: { date_type: 'weekly' },
          },
        );
        setData(info);
      })
      .catch(() => {})
      .finally(() => {
        finishLoading('charts', filter.module_id);
      });
  }

  useEffect(() => {
    if (filter) {
      getVersionLineChartData();
    }
  }, [filter]);

  return { loading, data };
}
